import {FC, useCallback} from 'react';
import StuckItem from './StuckItem';
import {EmployeeStuckItem} from '../../../../../types';
import {useFormikContext} from 'formik';

type StuckItemsListProps = {
  items: EmployeeStuckItem[],
  name: string,
  disabled: boolean,
}

const StuckItemsList: FC<StuckItemsListProps> = ({items, name, disabled}) => {
  const {values, setFieldValue} = useFormikContext<any>();

  const handleChange = useCallback(({target: {value}}) => {
    const checkedValues = values?.[name] || [];
    const isChecked = checkedValues.includes(value);

    const newValue = isChecked ?
      checkedValues.filter((checked) => checked !== value) :
      [...checkedValues, value];

    setFieldValue(name, newValue);
  }, [values?.[name]]);

  return (
    <ul className="stuck-items__list">
      {items.map(({code, desc}) => (
        <StuckItem
          label={desc}
          value={code}
          name={name}
          key={code}
          checked={values?.[name]?.includes(code)}
          disabled={disabled}
          onChange={handleChange}
        />
      ))}
    </ul>
  );
};

export default StuckItemsList;
